import { render, staticRenderFns } from "./TableOrderRecord.vue?vue&type=template&id=68fc1197&scoped=true&"
import script from "./TableOrderRecord.vue?vue&type=script&lang=js&"
export * from "./TableOrderRecord.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=68fc1197&lang=less&scoped=true&"
import style1 from "../../less/tableOrder.less?vue&type=style&index=1&id=68fc1197&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fc1197",
  null
  
)

export default component.exports